import { render, staticRenderFns } from "./DeviceDetailsTableGbs.vue?vue&type=template&id=3fbe0b0a&scoped=true&"
import script from "./DeviceDetailsTableGbs.vue?vue&type=script&lang=js&"
export * from "./DeviceDetailsTableGbs.vue?vue&type=script&lang=js&"
import style0 from "./DeviceDetailsTableGbs.vue?vue&type=style&index=0&id=3fbe0b0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbe0b0a",
  null
  
)

export default component.exports